import { NgModule } from '@angular/core';
import { GtmGgCartPageEventBuilder } from './gtm-gg-cart-page-event.builder';

@NgModule({})
export class GtmGgCartPageEventModule {
  constructor(_gtmGgCartPageEventBuilder: GtmGgCartPageEventBuilder) {}
}
